import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-usotc-agreement',
  templateUrl: './usotc-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UsotcAgreementComponent extends AgreementsDateBaseDirective {
}
